<script lang="ts">
  import { getStr, isMobile, lineEnforcer } from '../../../../common/util';

  export let testFreakData;
  export let readMoreUrl;
  export let totalReviewsToDisplay = 3;

  const isResponsive = isMobile();

  $: if (testFreakData.length > totalReviewsToDisplay) {
    testFreakData = testFreakData.slice(0, totalReviewsToDisplay);
  }
  $: nReviewLinesToDisplay = isResponsive ? 2 : [20, 12, 5, 2][testFreakData?.length];
</script>

<section class="brand-product-review-section">
  {#each testFreakData as testFreakItem}
    <section class="review-item">
      {#if testFreakItem?.title?.length > 0}
        <h4>{testFreakItem?.title}</h4>
      {/if}
      <p
        use:lineEnforcer={{
          lines: nReviewLinesToDisplay,
          appendClassOnOverflow: 'read-more-visible',
        }}
      >
        {testFreakItem?.extract || testFreakItem?.pros || testFreakItem?.cons}
        <a href={readMoreUrl} class="read-more-link">{getStr('extra.brand.readmore')}</a>
      </p>
    </section>
  {/each}
</section>

<style lang="scss">
  @import '../../styles/colors.new.scss';

  .brand-product-review-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-top: 8px;

    @include desktop-min-width {
      gap: 16px;
      margin-top: 0;
    }

    .review-item {
      display: flex;
      flex-direction: column;
      gap: 8px;
      color: $neutral-dark-01;

      &:not(:last-child) {
        padding-bottom: 8px;
        border-bottom: 1px solid $secondary-gray-02;

        @include desktop-min-width {
          padding-bottom: 16px;
        }
      }
      h4 {
        margin-block: 0;
        font-size: 13px;
        font-weight: 700;
        line-height: 15px;
        color: inherit;

        @include desktop-min-width {
          font-size: 16px;
          line-height: 18px;
        }
      }
      p {
        margin-block: 0;
        font-size: 14px;
        font-weight: 400;
        line-height: 16px;
        color: inherit;
        position: relative;

        &:not(.read-more-visible) .read-more-link {
          display: none;
        }
      }
      .read-more-link {
        position: absolute;
        bottom: 0;
        right: 0;
        background-color: white;
        color: $icon-only-icon-blue;
        padding-left: 1ch;
        font-weight: 500;
      }
    }
  }
</style>
